function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "external"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-10",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Oval"
}, /*#__PURE__*/React.createElement("g", {
  id: "path-1-link",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("circle", {
  id: "path-1",
  cx: 16,
  cy: 16,
  r: 16
})))), /*#__PURE__*/React.createElement("g", {
  id: "external-link",
  transform: "translate(8.000000, 8.000000)",
  stroke: "#474747"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.3333333,9.7777778 L13.3333333,14.2222222 C13.3333333,15.2040618 12.5373951,16 11.5555556,16 L1.77777778,16 C0.795938223,16 0,15.2040618 0,14.2222222 L0,4.44444444 C0,3.46666667 0.8,2.66666667 1.77777778,2.66666667 L6.22222222,2.66666667 M10.6666667,0 L16,0 L16,5.33333333 M6.22222222,9.7777778 L15.5,0.5",
  id: "Shape"
}))));

function SvgExternal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "external") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/external.9008da15.svg";
export { ForwardRef as ReactComponent };